<template>
	<div class="grid grid-cols-1 p-3 gap-4 border border-gray-300">
		<p>
			{{ $t("This product contains:") }}
		</p>
		<div class="grid grid-cols-1 gap-4">
			<ProductBundleItem
				v-for="product in bundleProducts"
				:key="product.Id"
				:product="product"
				:lazy-loading="true"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
const { bundleProducts } = storeToRefs(useProductStore());
</script>
